package com.flowyride.feature.account

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.flowyride.core.domain.account.AccountException
import com.flowyride.core.domain.account.AccountRepository
import com.flowyride.core.domain.account.SessionState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

data class SessionUiState(
    val session: SessionState = SessionState.Unknown,
    /** The stored session could not be checked (server down, offline): offer to retry. */
    val unreachable: Boolean = false,
)

/** Checks the stored session at startup and signs out. Drives which screen the app shows. */
class SessionViewModel(private val accounts: AccountRepository) : ViewModel() {

    private val unreachable = MutableStateFlow(false)

    val state: StateFlow<SessionUiState> = combine(accounts.session, unreachable, ::SessionUiState)
        .stateIn(viewModelScope, SharingStarted.Eagerly, SessionUiState(accounts.session.value))

    init {
        restore()
    }

    fun restore() {
        unreachable.value = false
        viewModelScope.launch {
            try {
                accounts.restoreSession()
            } catch (e: AccountException) {
                unreachable.value = true
            }
        }
    }

    fun signOut() {
        viewModelScope.launch { accounts.signOut() }
    }
}
